// extracted by css-extract-rspack-plugin
var _1 = "bt";
var _2 = "br";
var _3 = "bq";
var _4 = "bs";
var _5 = "bp";
export { _1 as "itemTemplateComponent", _2 as "left", _3 as "panel", _4 as "repeaterComponent", _5 as "shoppingMallsListComponent" }
